/**
 * Convert a string to title case
 * @param str - The string to convert
 * @returns The title case string
 */
export function toTitleCase(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

/**
 * Normalize a string to alphanumeric characters only.
 * Trims, lowercases, replaces spaces with underscores, and removes non-alphanumeric characters.
 * @param str - The string to normalize
 * @returns The normalized string
 */
export function normalizeToAlphanumeric(str: string): string {
  return str
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_-]/g, "");
}
